import { getAuthCode } from "./getAuthCode";
export const updatePersona = async(persona) => {
    try {
      const authCode = await getAuthCode()
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/updatePersona", {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({auth_code:authCode,persona:persona}),
      });
      const result = await response.json();
    } catch (error) {
      console.log(error);
    }
}